<template>
<div class="ssContainer">
  <div class="ssShowArea">
    <div class="ssArea">
      <h2 class="title">系统设置</h2>
      <el-form id="configForm" label-width="180px" label-position="left" class="setingBox" v-loading="loading">
        <div class="basicInfo setingItem" v-for="(settingitem, index) in setting" :key="index">
          <el-form-item :label="settingitem.comment">
              <!-- 文本框-->
              <div v-if="settingitem.type === 0" class="div-inline">
                <el-input :name="settingitem.code" v-model="settingitem.value" @blur="changeCode(settingitem.code,settingitem.value)"></el-input>
              </div>

              <!-- 复选框 -->
              <div v-else-if="settingitem.type === 1" class="div-inline">
                <el-checkbox-group :name="settingitem.code" v-model="settingitem.checked" v-for="(option, optionindex) in settingitem.options" :key="optionindex">
                  <el-checkbox :label="option"></el-checkbox>
                </el-checkbox-group>
              </div>

              <!-- 单选框 -->
              <div v-else-if="settingitem.type === 2" class="div-inline">
                <el-radio-group v-model="settingitem.selected" size="small">
                  <el-radio :key="index" v-for="(option, index) in settingitem.options" :label="option.label">{{option.value}}</el-radio>
                </el-radio-group>
              </div>
              <div v-else-if="settingitem.type === 3">
                <!-- :props="{ expandTrigger: 'hover' }" -->
                <el-cascader v-model="proviceCityValue" :options="proviceCityOptions" @change="proviceCityHandleChange"></el-cascader>
              </div>

              <!-- logo图片上传 -->
              <div class="logo-style" v-if="settingitem.code == 'SYS_LOGO'">
                <!-- <h6>LOGO上传</h6> -->
                <el-upload
                  :class="[{'demo-httpRequestImg': isHidden}, 'avatar-uploader']"
                  action
                  list-type="picture-card"
                  :file-list="fileList"
                  :before-upload="beforeAvatarUpload"
                  :http-request="handleHttpRequest"
                  :on-remove="handleRemove"
                  :limit='1'>
                  <i class="el-icon-plus"></i>
                </el-upload>
                <p class="p-style">注： 请上传50 * 50像素、大小不超过100KB的图片</p>
              </div>

              <div v-if="settingitem.hint" class="div-inline">
                <span class="tips">{{settingitem.hint}}</span>
              </div>
          </el-form-item>

          <!-- <div class="logo-style" v-if="settingitem.code == 'SYS_LOGO'">
            <h6>LOGO上传</h6>
            <el-upload
              :class="[{'demo-httpRequestImg': isHidden}, 'avatar-uploader']"
              action
              list-type="picture-card"
              :file-list="fileList"
              :before-upload="beforeAvatarUpload"
              :http-request="handleHttpRequest"
              :on-remove="handleRemove"
              :limit='1'>
              <i class="el-icon-plus"></i>
            </el-upload>
            <p class="p-style">注： 请上传50 * 50像素、大小不超过100KB的图片</p>
          </div> -->

        </div>
        <el-form-item>
          <el-button v-if="true || rolePermit('sysSet:edit')" class="biggerButton" type="primary" @click="flush" style="width:400px;">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>

</div>
</template>

<script>
import bus from '@/bus/bus';
export default {
  components: {
  },
  data() {
    return {
      loading: true,
      setting: [],
      system_name: '',
      version: '',
      //省市选择 ======
      proviceCityValue:  [],
      proviceCityOptions: [],
      values:'',
      fileList: [],
      isHidden: false,
      file: null
    };
  },
  created() {
    this.getProvice()
  },
  mounted() {
    this.query();
  },
  methods: {
    changeCode(code,data){
      // console.log(code);
      // console.log(data);
      if(code === 'SYS_NAME'){
        this.values=data
        return
      }
    },
    query() {
      this.request.get("/front/system/config/query").then(rs => {
        // console.log(rs);
        if (rs.code == 200) {
          let data = rs.data;
          this.loading = false;
          this.setting = [];
          for (let i = 0;i < data.length;++i) {
            let item = data[i];
            if (item.type === 1) {
              // console.log(item)
              let item_options = item.optionValue && item.optionValue.split(",");
              let item_checked = item.value.split(",");
              this.setting.push({
                id: item.id,
                type: item.type,
                code: item.code,
                comment: item.comment,
                hint: item.hint,
                options: item_options,
                checked: item_checked
              });
            } else if (item.type === 2) {
              let options = item.optionValue && item.optionValue.split(",");
              let item_options = [];
              for (let j = 0;j < options.length;++j) {
                let option = options[j];
                item_options.push({
                  label: j,
                  value: option
                });
              }
              this.setting.push({
                id: item.id,
                selected: parseInt(item.value),
                type: item.type,
                code: item.code,
                comment: item.comment,
                hint: item.hint,
                options: item_options
              });
            } else {
              this.setting.push(item);
            }

            if (item.code === 'SYS_NAME') {
              this.system_name = item.value;
            } else if (item.code === 'SYS_VERSION') {
              this.version = item.value;
            } else if (item.code === 'SYS_LOGO') {
              this.fileList = [{
                name: item.value,
                url: `${this.baseUrlAddr}/front/picUploadAndDownload/download2?fileName=${item.value}`
              }]
              this.getImageFileFromUrl(`${this.baseUrlAddr}/front/picUploadAndDownload/download2?fileName=${item.value}`, item.value).then(res => {
                this.file = res
                this.isHidden = true
              })
            } else if(item.type ==3){
              let proviceCityValue = item.value.split('_')
              if(proviceCityValue.length==1){
                this.proviceCityValue =[proviceCityValue[0]*1]
              }else if(proviceCityValue.length==2){
                this.proviceCityValue =[proviceCityValue[0]*1,proviceCityValue[1]*1]
              }
            }
          }
        }
      });
    },
    flush() {
      if(this.values.length>13){
        return this.msg.warn('系统名称长度不能大于13位')
      }else if(this.values.length<1&&this.values!==''){
        return this.msg.warn('系统名称长度不能小于1位')
      }
      if (!this.file) return this.msg.error("请上传图片！");

      let config = [];
      let system_name_new = '';
      let version_new = '';
      this.setting.forEach(e => {
        // console.log(e)
        if (e.type === 1) {
          config.push({
            ...e,
            id: e.id,
            value: e.checked.join(",")
          })
        } else if (e.type === 2) {
           config.push({
              ...e,
              id: e.id,
              value: e.selected
           })
        } else if(e.type === 3){
            config.push({
              ...e,
              id:e.id,
              value: this.proviceCityValue.join('_')
            })
        } else if(e.code == 'SYS_LOGO'){
          console.log('SYS_LOGO')
        } else {
          config.push({
            ...e,
            id: e.id,
            value: e.value
          })
        }

        if (e.code === 'SYS_NAME') {
          system_name_new = e.value;
        } else if (e.code === 'SYS_VERSION') {
          version_new = e.value;
        }
      });

      if(config.id==7){
        //  config.push({
        //   id:8,value:this.proviceCityValue[0].toString()
        // })
        config[6].value =this.proviceCityValue[0].toString()
      }

      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("config", JSON.stringify(config));
      // console.log(formData)
      // return console.log(config)

      this.request.post("/front/system/config/update", formData).then(rs => {
        // console.log(rs);
        
        if (rs.code !== 200) {
          if(rs.code==500){
          return this.$message.error(rs.msg)
        }
          return
        }
        this.$message.success("系统配置信息修改成功!");
        this.setting.forEach(e => {

        });
        // if (this.system_name !== system_name_new || this.version !== version_new) {
          this.storage.setStorage('sysname', system_name_new, 2592000);
          // this.$emit("systemNameChange", {
          //   system_name: system_name_new,
          //   version: version_new
          // });
          bus.$emit('changeSysname', system_name_new);
        // }
      });
    },
    // 地址转file对象
    getImageFileFromUrl(url, imageName) {
      return new Promise((resolve, reject) => {
          var blob = null;
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url);
          xhr.setRequestHeader('Accept', 'image/jpeg');
          xhr.responseType = "blob";
          xhr.onload = () => {
              blob = xhr.response;
              let imgFile = new File([blob], imageName, { type: 'image/jpeg' });
              resolve(imgFile);
          };
          xhr.onerror = (e) => {
              reject(e)
          };
          xhr.send();
      });
    },
    // 省市======
    async getProvice() {
      const {
        code,
        data,
        msg
      } = await this.request.get('/front/region/queryAll')
      if (code != 200) {
        return this.$message.error(msg)
      }
      let proviceCityOptions = data.map(item => {
        if (item.cities.length > 0) {
          // console.log(`item`, item)
          item.label = item.province
          // item.value = [item.longitude, item.latitude].toString()
          item.value = item.id
          // delete item.province
          delete item.longitude
          delete item.latitude
          item.cities.map(itemitem => {
            itemitem.label = itemitem.province
            // itemitem.value = [itemitem.longitude, itemitem.latitude].toString()
            itemitem.value = itemitem.id

            delete itemitem.province
            delete itemitem.longitude
            delete itemitem.latitude
            delete itemitem.province
            itemitem.label = itemitem.city
            delete itemitem.city
            // itemitem = [{value:item.id,label:`~全${item.province}`},...itemitem]
            // itemitem.unshift({value:item.id,label:`~全${item.province}`})
            // console.log(`itemitem`, itemitem)
            return itemitem
          })
          item.children = [...item.cities]
          delete item.cities
            item.children.unshift({value:item.id,label:`全${item.province}`})
          return item
        } else {
          item.label = item.province
          // item.value = [item.longitude, item.latitude].toString()
          item.value = item.id
          delete item.province
          delete item.longitude
          delete item.latitude
          return item
        }
      })
      proviceCityOptions.unshift({label:'中国',value:999})
      this.proviceCityOptions = proviceCityOptions
    },
    async proviceCityHandleChange() {
      console.log(`this.proviceCityValue`, this.proviceCityValue)
    },
    /**
     * @Description 图片上传成功钩子
     * @Author      YOYO     -    2022-05-09
     * @param       {object} res  [接口返回的数据]
     * @param       {object} file [文件对象]
     */
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    /**
     * @Description 上传logo的校验
     * @Author      YOYO     -    2022-05-09
     * @param       {object} file [文件对象]
     * @return      {[type]}      [description]
     */
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isJPG2 = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024  < 100;

      // 格式校验
      if (!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning("只支持jpeg或jpg或png格式图片");
        return false
      }
      // 大小校验
      if (!isLt5M) {
        this.$message.warning("请上传100KB以内的图片!");
        return false
      }

      // 宽高校验
      const isSize = new Promise(function(resolve, reject) {
        let width = 50
        let height = 50
        let _URL = window.URL || window.webkitURL
        let img = new Image()

        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        }

        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return file;
      }, () => {
        this.$message.warning('上传的图片宽高必须是50*50!')
        return Promise.reject()
      });

      return (isJPG || isJPG2 || isPNG) && isLt5M && isSize;
    },
    handleHttpRequest(obj) {
      this.isHidden = true
      // this.httpRequestImg = true;
      this.file = obj.file;
      this.msg.success('图片上传成功')
    },
    handleRemove(file, fileList) {
      this.isHidden = false
      this.fileList = [];
      this.file = null
    },
  }
};
</script>

<style lang="scss" scoped>
// @import "../../assets/css/AddressSelect.css";
.as-bmap-default{
    min-height: 300px;
    padding-right:10px;
}

.as-auto-complete-item {
    padding: 4px 0;
    border-bottom: 1px solid #F6F6F6;
}

.as-auto-complete-group {
    font-size: 12px;
    padding: 4px 6px;
}

.as-auto-complete-group span {
    color: #666;
    font-weight: bold;
}
.ssContainer {
  width: 100%;
  // min-height: 100%;
  overflow: auto;
  position: absolute;
  height: 96%;
  padding: 20px;
  border-radius: 4px;
  box-sizing: border-box;

  .ssShowArea {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px;
    overflow: auto;
    box-sizing: border-box;
    .ssArea {
      width: 100%;
      min-height: 100%;
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
    }
  }

  .title {
    font-size: 30px;
    color: #333;
    padding: 0 10px 10px;
  }

  .setingBox {
    margin-top: 20px;
    padding: 0 87px;

    .setingItem {
      // padding: 0 87px;

      h3 {
        font-size: 22px;
        margin-bottom: 20px;
        position: relative;
        color: #333;
        right: 17px;
        //   &::after{
        //     position: absolute;
        //     content: '';
        //     border: 6px solid transparent;
        //     border-top: 6px solid #333;
        //     // left: 137px;
        //     top: 12px;
        //   }
      }

      .el-form-item {

        // padding-left: 30px;
        .el-input {
          // width: 600px;
          width: 480px;
        }

        .tips {
          margin-left: 20px;
          color: #f56c6c;
        }

        .el-radio-group {
          margin-right: 10px;
        }
      }
    }
  }
}
.div-inline {
  display: inline;
}

.logo-style {
  // border: 1px solid red;
  margin-bottom: 10px;
  h6 {
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    box-sizing: border-box;
    width: 168px;
    margin-right: 12px;
  }
  .p-style {
    display: inline-block;
    font-size: 10px;
    color: #999;
    margin-left: 25px;
    vertical-align: -40px;
  }
}

.biggerButton {
  // width: 48%;
  // margin-left: 13%;
  background: #2662dc;
}

.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus,
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #67c23a;
  max-width: 500px;
}
</style>
<style lang='scss'>
.logo-style {
  .avatar-uploader {
    display: inline-block;
  }
  .el-upload--picture-card {
    width: 60px;
    height: 60px;
    line-height: 60px;
  }
  .el-upload-list--picture-card {
    margin-bottom: 0
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 60px;
    height: 60px;
    text-align: center;
  }
  .el-upload--picture-card i {
    font-size: 20px;
  }
  .demo-httpRequestImg {
    .el-upload--picture-card {
       display: none;
    }
  } 
  // .avatar-uploader .el-upload {
  //   border: 1px dashed #d9d9d9;
  //   border-radius: 6px;
  //   cursor: pointer;
  //   position: relative;
  //   overflow: hidden;
  // }
  // .avatar-uploader .el-upload:hover {
  //   border-color: #409EFF;
  // }
  // .avatar-uploader-icon {
  //   font-size: 20px;
  //   color: #8c939d;
  //   width: 50px;
  //   height: 50px;
  //   line-height: 50px;
  //   text-align: center;
  // }
  // .avatar {
  //   width: 50px;
  //   height: 50px;
  //   display: block;
  // }
}
</style>
